import { AppModule } from 'app/module';
import { JobsList } from 'module/jobsList/main';
import { getJson } from 'util/xhr';
import { ENDPOINT_HOKIFY_JOBS } from 'app/endpoints';
import { stringToSlug } from 'util/url';
import Template from './template.hbs';
import './styles.scss';

export class HokifyJobsAd extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    load() {
        this.loadJobs();
    }

    loadJobs() {
        if (this.props.active) {
            if (this.fetch) {
                this.fetch.abort();
            }

            this.fetch = getJson(
                `${ENDPOINT_HOKIFY_JOBS}?keyword=${stringToSlug(this.props.keywords)}&location=${stringToSlug(this.props.locations)}`,
                {},
                (response) => this.onResponse(response),
                () => this.onError(),
            );
        }
    }

    onResponse(response) {
        if (response.showJobsList) {
            const hokifyJobIds = [];

            response.jobIds.forEach((id) => {
                hokifyJobIds.push(`J${id}`);
            });

            // BO hokify tracking
            window.dataLayer.push({
                event: 'hokify-impressions',
                hokifyJobIds,
                hokifyLocId: response.locId,
            });
            // EO hokify tracking

            this.updateProps(response, true);
        }
    }

    onError() {
        this.dom.link.href = this.dom.link.getAttribute('data-href');
    }

    domBindings() {
        return {
            inner: '.m-hokifyJobsAd__inner',
            jobsList: '.m-hokifyJobsAd__jobsList .m-jobsList',
            link: '.m-hokifyJobsAd__link',
            image: '.m-hokifyJobsAd__image',
        };
    }

    subs() {
        if (this.dom.jobsList) {
            this.jobsList = new JobsList(this.dom.jobsList);
        }
    }

    getPropsFromDom() {
        return {
            active: !!this.dom.link,
            keywords: this.dom.el.getAttribute('data-keywords'),
            locations: this.dom.el.getAttribute('data-locations'),
        };
    }
}
